// AOS Animations
import AOS from 'aos';
AOS.init({
    offset: ( window.screen.width > 768 ) ? 150 : 50,
    duration: 500,
    delay: 50,
});

// Other
import "/src/style/main.scss"

import './scripts/modules/functions'

// Modules
// import Navigation from './scripts/modules/navigation'
// Navigation().init()

import testimonialsSlider from "./scripts/modules/testimonialsSlider";
testimonialsSlider().init()

import heroSlider from "./scripts/modules/heroSlider";
heroSlider().init()

import projectSlider from "./scripts/modules/single-project";
projectSlider().init()

import Accordions from "./scripts/modules/accordions";
Accordions().init()

import SmoothAnchor from "./scripts/modules/smooth-anchor";
SmoothAnchor().init()

import SiteHeader from "./scripts/modules/site-header";
SiteHeader().init()

import ServiceAccordion from "./scripts/modules/single-service";
ServiceAccordion().init()

import FeaturedSlider from "./scripts/modules/featured-slider";
FeaturedSlider().init()

import AsscociationsSlider from "./scripts/modules/associations-slider";
AsscociationsSlider().init()

import WorkFilters from './scripts/modules/work-filters'
WorkFilters().init()

import NewsFilters from './scripts/modules/news-filters'
NewsFilters().init()

import CustomSelect from './scripts/modules/custom-select'
CustomSelect().init()

import Parallax from './scripts/modules/parallax'
Parallax().init()




import Contact from "./scripts/modules/contact";
Contact().init()